import * as React from 'react';
import { render } from 'react-dom';
import Board, { Props } from './board';

export function renderBoard(id: string, props: Props, callback?: () => void) {
    if (document) {
        const container = document.getElementById(id);
        if (container) {
            render(<Board {...props} />, container, callback);
        }
    }
}
